// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import { StyleSheet } from "react-native";
import colors from "../../config/colors";
import fonts from "../../config/fonts";
const NewDigestateWithdrawalStyle = StyleSheet.create({
  header: {
    alignItems: "center",
    padding: 12,
    color: colors.white,
    borderRadius: 16,
    shadowColor: colors.white,
    shadowOffset: { width: 0, height: 2 },
    backgroundColor:colors.white,
    shadowOpacity: 0.2,
    shadowRadius: 4,
    elevation: 3,
    marginTop: 10,
    marginBottom: 5,
    fontFamily: fonts.regular,
  },
  iconContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: colors.white,
  },
  iconRow: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 10, 
  },
  iconSpacing: {
    marginLeft: 10,
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
    flex: 1,
    color: colors.green,
    fontFamily: fonts.regular,
  },
  content: {
    paddingHorizontal: 12,
    paddingVertical: 16,
    marginBottom: 10,
    fontFamily: fonts.regular,
  },
  rowContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 8,
    paddingVertical: 5,
    fontFamily: fonts.regular,
  },
  labelContainer: {
    width: "50%",
  },
  label: {
    fontSize: 16,
    fontWeight: "bold",
    color: colors.green,
    fontFamily: fonts.regular,
  },
  inputContainer: {
    width: "50%",
  },
  input: {
    paddingVertical: 8,
    fontSize: 16,
    borderWidth: 1,
    borderColor: colors.white,
    fontFamily: fonts.regular,
  },
  buttonContainer: {
    marginTop: 16,
    alignItems: "center",
  },
  button: {
    paddingVertical: 12,
    paddingHorizontal: 16,
  },
  buttonText: {
    fontSize: 18,
    fontWeight: "bold",
    color: colors.white,
    fontFamily: fonts.regular,
  },
});

export default NewDigestateWithdrawalStyle;
